module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "PROLOGUE.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-27"
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_vm._v("PROLOGUE")])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("S")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("OMETIMES")]), _vm._v(" "), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("THE")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("PATH")]), _vm._v(" from the family-owned bed-and-breakfast to the small, private cemetery that overlooked the sea seemed longer to reach than it actually was.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Other times, like today, he wasn’t even aware of how long it took to get there. One second, Richard Roman was deciding that he wanted to share a few moments with his wife and his best friend, the next he was already standing before their headstones, talking to the two people who had known him the best and, just possibly, the longest.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His Amy had been in this spot overlooking the sea a long while—sometimes it felt as if she had "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("always")]), _vm._v(" been here, whereas Daniel had been here only a little while. Richard missed them both so very much.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But it helped to come here to talk to them both whenever he was troubled or happy.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Someday, he himself would be laid to rest here, Richard thought. Buried next to his Amy.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But not for many years to come.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His girls needed him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The four of them, ranging in age from twenty-one to twenty-eight were well along on their journey into womanhood, but they still needed him, needed his guidance.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Looks like Alex won’t be wearing your wedding dress after all, Amy, even though she had her heart set on it. She’s too tall and just a touch too curvy to get into it. I know that Wyatt has no complaints in that department, but Alex really did think she’d be walking down the aisle in your dress. She was very disappointed.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He shook his head, recalling the stricken look on Alex’s face when she told him about the dress. “I know you’re thinking,” he continued, addressing Amy and Dan as though they were standing right in front of him, “that alternations can be made since the wedding isn’t until Christmas, but Alex feels that it’s disrespectful to alter the dress you wore when you married me. At times it’s hard to believe it’s Alex talking, but she’s got this whole sensitive side to her that she never let on about.” He chuckled. “Who knew, right, Dan?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And then he smiled. The afternoon sun played along the planes of his face. “I guess your boy does bring out the best in Alex. None of us saw that coming,” he confessed, then rethought his words. “Well, except for you, of course, Dan,” he admitted. “You knew all along they were right for each other, didn’t you? Otherwise, you wouldn’t have insisted that Wyatt finish that book about the inn you started working on just before you died. If it hadn’t been for that deathbed promise you extracted from Wyatt, Alex wouldn’t be on the hunt for a wedding dress and my third offspring wouldn’t be running around like a chicken without her head because Alex put her in charge of planning the reception. Cris, naturally, will be doing the cooking. Or rather, have the meal all ready for the reception right after the ceremony. If I know her, she’ll be up all night the night before, getting everything prepared and just so. She is a perfectionist, our Cris. She takes after her mom,” he added. “It’s really a shame that her husband died so young. Michael was a great guy.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Speaking of which,” Richard said, interrupting himself, “one of Cris’s old acquaintances, Shane McCallister is doing some renovation work on the inn for me. I’ve seen the way he eyes Cris when he thinks no one is watching. That young man is really taken with her. Who knows? There might just be a second wedding soon. I certainly hope so. Cris deserves to be happy, like Alex.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A wistful smile played on Richard’s lips, and tears glimmered in his eyes as he looked from one headstone to the other. “I wish you both could be present for Alex and Dan’s wedding. Yes, I know, you’ll be here in spirit and that’s an enormous comfort to your girls, but sometimes—” Richard dropped his voice to a whisper “—it would be nice to actually see you, touch you....”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He sighed as he glanced toward the rear of the inn. “I guess I’d better be getting back. I’ll keep you posted on the search for Alex’s wedding dress and on how everyone else is doing. I miss you both more than words can ever say.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He turned and made his way back to the inn. Unlike the journey to the cemetery, the journey back always felt infinity longer, because he made it knowing he was all alone.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph-21"
  })])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-632e288e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PROLOGUE.vue
// module id = 78
// module chunks = 0